import {
    Component,
    Event,
    EventEmitter,
    h,
    Host,
    Prop,
    State,
} from '@stencil/core';

let nextUniqueId = 0;

@Component({
    tag: 'portal-checkbox',
    styleUrl: 'portal-checkbox.scss',
    shadow: true,
})
export class PortalCheckbox {

    /**
   * Aria label of the checkbox
   */
    @Prop() ariaLabel: ARIAMixin['ariaLabel'] = '';

    /**
   * Default selection state
   */
    @Prop() defaultChecked: boolean = false;

    /**
   * Checkbox's input id
   */
    @Prop() uniqueId: string = `portal-checkbox-${++nextUniqueId}`;

    /**
   * Event emitting boolean value whenever state of checkbox changes
   */
    @Event({
        eventName: 'valueChange',
        composed: true,
        cancelable: true,
        bubbles: true,
    }) valueChange: EventEmitter<boolean>;

    @State() checked = this.defaultChecked;

    render() {
        return (
            <Host>
                <label htmlFor={this.uniqueId} class={`portal-material-checkbox ${this.checked ? 'portal-material-checkbox-checked' : ''}`}
                    aria-label={this.ariaLabel}
                    aria-checked={this.checked}>
                    <input
                        id={this.uniqueId}
                        type="checkbox"
                        defaultChecked={this.defaultChecked}
                        onClick={(event) => this._onInputClick(event)}/>
                    <div class="portal-material-checkbox-before"></div>
                    <span class="portal-material-checkbox-label"><slot/></span>
                    <div class="portal-material-checkbox-after"></div>
                </label>
            </Host>
        );
    }

    private _onInputClick(event: UIEvent): void {
        event.stopPropagation();
        this.checked = !this.checked;
        this.valueChange.emit(this.checked);
    }
}
